import { CloudCustomerTypeMapper } from "@omni/mappers/customer/shared/enums/customerType.enumMapper";
import { ComponentsCustomer } from "@omni/types/components/customer/customer.model";
import { ComponentsCustomerType } from "@omni/types/components/customer/shared/customerType.enum";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { Config } from "@/utils/config.utils";

import { UpdateCustomerRequest } from "./customer.types";

const getVatData = (customer: ComponentsCustomer) => {
    if (
        customer.customerType !== ComponentsCustomerType.B2B ||
        !customer.vatNr
    ) {
        return {};
    }

    return {
        vatNr: `${customer.vatNrPrefix}${customer.vatNr}`,
        companyName: customer.companyName
    };
};

export const UpdateCustomerMapper: ModelMapper<
    ComponentsCustomer,
    UpdateCustomerRequest
> = (model) => {
    const vatData = getVatData(model);

    return {
        firstName: model.firstName,
        lastName: model.lastName,
        bonusCardRequested: model.bonusCardRequested,
        customerType: CloudCustomerTypeMapper.fromComponentsToCloud(
            model.customerType
        ),
        email: model.email,
        guest: model.guest,
        phone:
            model.phone && model.phonePrefix
                ? `${model.phonePrefix}${model.phone}`
                : null,
        bonusCardNumber:
            model.bonusCardNumber || model.eBonusCardNumber || null,
        vatNr: vatData.vatNr || null,
        companyName: vatData.companyName || null,
        dateOfBirth: model.dateOfBirth || null,
        language: model.language || Config.getLocale(),
        favouriteStoreId: model.favouriteStoreId || null,
        newsLetterSubscribed: model.newsLetterSubscribed,
        receiveSms: model.receiveSms,
        requestInvoice: model.requestInvoice
    };
};
